<template>
    <div id="page-duplication-detail">
        <black-list-ip-sidebar @reload-ips="onReloadIpList" :isSidebarActive="isSidebarActive" @closeSidebar="toggleSidebar" />

        <div class="vx-card pl-5 pr-5">
            <vs-table 
                :data="ips"
                :max-items="itemsPerPage"
                pagination
                :stripe="true"
                search
            >
                <template slot="header">
                    <!-- ITEMS PER PAGE -->
                    <div class="flex-grow">
                        <vs-dropdown vs-trigger-click class="cursor-pointer">
                            <div class="p-3 border border-solid d-theme-border-grey-light rounded-full cursor-pointer flex items-center justify-between font-medium">
                                <span class="mr-2">
                                    {{ itemsPerPage }}
                                </span>
                                <feather-icon
                                    icon="ChevronDownIcon"
                                    svgClasses="h-4 w-4"
                                />
                            </div>
                            <vs-dropdown-menu>
                                <vs-dropdown-item :key="ipp" v-for="ipp in [15,25,50,100]" @click="itemsPerPage = ipp"><span>{{ipp}}</span></vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <vs-button v-if="$acl.check('createdBlackIp')" @click="newBlackIp" color="primary" type="filled" class="mr-5" icon="person_add">Thêm</vs-button>
                </template>
                <template slot="thead">
                    <vs-th
                        :key="idx"
                        v-for="(h,idx) in header"
                        :sort-key="h.field"
                    >
                        {{ h.title }}
                    </vs-th>
                    <vs-th>Actions</vs-th>
                </template>
                <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                        <vs-td :key="idx" v-for="(h,idx) in header" :data="data[indextr][h.field]">
                            <template v-if="h.render">
                                {{ h.render(data[indextr][h.field]) }}
                            </template>
                            <template v-else>
                                {{ data[indextr][h.field] }}
                            </template>
                        </vs-td>
                        <vs-td v-if="$acl.check('deleteBlackIpPermission')">
                            <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(data[indextr])" />
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import vSelect from 'vue-select';
import moment from 'moment';
import { AclRule } from 'vue-acl';
import BlackListIpSidebar from './BlackListIpSidebar';

export default {
    data(){
        return {
            itemsPerPage: 15,
            header: [],
            ips: [],
            isSidebarActive: false
        }
    },
    components: {
        vSelect,
        BlackListIpSidebar
    },
    computed: {
        fetchAllBlackIpPermission(){
            return new AclRule('store_black_ip').generate();
        },
        fetchBlackIpPermission(){
            return new AclRule('store_black_ip').or('child_store_black_ip').generate();
        },
        createdBlackIp(){
            return new AclRule('create_black_ip').or('child_create_black_ip').generate();
        },
        deleteBlackIpPermission(){
            return new AclRule('destroy_black_ip').or('child_destroy_black_ip').generate();
        }
    },
    methods:{
        fetchBlackIp() {
            if(this.$acl.not.check('fetchBlackIpPermission')) return;

            let vm = this;
            
            this.$http.get("black_ip").then((res) => {
                vm.ips = res.data.data;
            });
        },
        initHeader(){
            let header = [ 
                { title:"IP", field:"ip" }
            ];

            if(this.$acl.check('fetchAllBlackIpPermission')){
                header.push({ title:"Người dùng", field:"user" });
            }

            header.push({ title:"Note", field:"note" });
            this.header = header;
        },
        newBlackIp(){
            this.selectedIp = null;
            this.toggleSidebar(true);
        },
        toggleSidebar(val){
            this.isSidebarActive = val;
        },
        onReloadIpList(){
            this.fetchBlackIp();
        },
        confirmDeleteRecord(item){
            let vm = this;
            Swal.fire({
                title: '',
                text: "Bạn có chắc chắn muốn xóa black IP "+item.ip+"?",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Xóa'
                }).then((result) => {
                if (result.isConfirmed) {
                    vm.$http.delete(`black_ip/${item.id}`)
                        .then(res => {
                            if(res.data.code == 0){
                                Swal.fire("", "Xóa black IP "+item.ip+" thành công", 'success');
                                vm.fetchBlackIp();
                            }
                        });
                }
            })
        },
    },
    created(){
        this.initHeader();
        this.fetchBlackIp();
    }
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
        z-index: 52010;
    }

    ::v-deep .vs-sidebar {
        z-index: 52010;
        width: 400px;
        max-width: 90vw;

        .img-upload {
            margin-top: 2rem;

            .con-img-upload {
                padding: 0;
            }

            .con-input-upload {
                width: 100%;
                margin: 0;
            }
        }
    }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}

.swal2-container{
    z-index: 99999;
}
</style>
